import { menuInteractions } from "./menu";

export function mobile() {
  menuInteractions();
}
